import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}
